<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <h4 class="card-title">Procurement</h4>
          </div>
          <div class="col-6">
            <div class="float-right">
              <b-button
                variant="primary"
                class="btn btn-label btn-primary"
                v-b-modal.modal_addItem
                @click="clearAddModal"
                ><i class="bx bx-plus label-icon"></i>Add Item</b-button
              >

              <!-- Add Time Modal -->
              <!-- 

                 -->
              <b-modal
                id="modal_addItem"
                title="Add Item"
                title-class="font-18"
                ok-title="Add Item"
                @ok="addItem"
              >
                <div class="mt-4 mt-lg-0 mb-4">
                  <div>
                    <b-form ref="form">
                      <b-form-group
                        label="Product/Service Name"
                        label-for="input-name"
                        :invalid-feedback="invalidFeedbackName"
                        :state="productName ? productInputValid : null"
                      >
                        <b-form-input
                          id="input-name"
                          v-model="productName"
                          :state="productName ? productInputValid : null"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group label="Type">
                        <b-form-select
                          v-model="type"
                          :options="typeOptions"
                        ></b-form-select>
                      </b-form-group>
                      <b-form-group
                        label="Quoted Amount"
                        label-for="input-quoted"
                        :invalid-feedback="invalidFeedbackQuotedAmount"
                        :state="quotedAmount ? quotedAmountValid : null"
                      >
                        <b-form-input
                          id="input-quoted"
                          v-model="quotedAmount"
                          :state="quotedAmount ? quotedAmountValid : null"
                          @keypress="
                            currencyAutoFormatter($event, quotedAmount)
                          "
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label="Received Amount"
                        label-for="input-received"
                        :invalid-feedback="invalidFeedbackReceivedAmount"
                        :state="receivedAmount ? receivedAmountValid : null"
                      >
                        <b-form-input
                          id="input-received"
                          v-model="receivedAmount"
                          :state="receivedAmount ? receivedAmountValid : null"
                          @keypress="
                            currencyAutoFormatter($event, receivedAmount)
                          "
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label="Mark-up"
                        label-for="input-markup"
                        :invalid-feedback="invalidFeedbackMarkup"
                        :state="markup ? markupValid : null"
                      >
                        <div class="mb-3">
                          <b-form-radio v-model="markupType" value="flatRate"
                            >Flat Rate</b-form-radio
                          >
                          <b-form-radio v-model="markupType" value="dollar"
                            >Cost Plus Dollar Amount</b-form-radio
                          >
                          <b-form-radio v-model="markupType" value="percentage"
                            >Cost Plus Percentage</b-form-radio
                          >
                        </div>
                        <b-input-group
                          :append="markupType === 'percentage' ? '%' : ''"
                          :prepend="
                            markupType === 'flatRate' || markupType === 'dollar'
                              ? '$'
                              : ''
                          "
                        >
                          <b-form-input
                            id="input-markup"
                            v-model="markup"
                            :state="markup ? markupValid : null"
                            :disabled="markupType === null"
                            @keypress="currencyAutoFormatter($event, markup)"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>

                      <b-form-checkbox
                        class="mt-3 mb-4"
                        id="checkbox-ordered"
                        v-model="ordered"
                        name="checkbox-ordered"
                        size="lg"
                      >
                        Product or service has been ordered
                      </b-form-checkbox>
                      <b-form-checkbox
                        class="mb-4"
                        id="checkbox-received"
                        v-model="received"
                        name="checkbox-received"
                        size="lg"
                      >
                        Product or service has been received
                      </b-form-checkbox>
                      <b-form-checkbox
                        class="mb-4"
                        id="checkbox-invoiced"
                        v-model="invoiced"
                        name="checkbox-invoiced"
                        size="lg"
                      >
                        Invoice has been received
                      </b-form-checkbox>
                      <b-form-checkbox
                        class="mb-4"
                        id="checkbox-billable"
                        v-model="billable"
                        name="checkbox-billable"
                        size="lg"
                      >
                        Exclude item from billing
                      </b-form-checkbox>
                      <b-form-group label="Image of Quote">
                        <vue-dropzone
                          id="fileUploader"
                          ref="fileUploader"
                          :use-custom-slot="true"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAddedQuote"
                        >
                          <div class="dropzone-custom-content">
                            <i
                              class="display-4 text-muted bx bxs-cloud-upload"
                            ></i>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </vue-dropzone>
                      </b-form-group>
                      <b-form-group label="Image of Invoice">
                        <vue-dropzone
                          id="fileUploader"
                          ref="fileUploader"
                          :use-custom-slot="true"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAddedInvoice"
                        >
                          <div class="dropzone-custom-content">
                            <i
                              class="display-4 text-muted bx bxs-cloud-upload"
                            ></i>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </vue-dropzone>
                      </b-form-group>
                    </b-form>
                  </div>
                </div>
                <a
                  :hidden="!submitErrorMessage"
                  class="badge badge-danger font-size-10 mr-1 ml-1 no-pointer float-right"
                  >Please input a valid Product/Service Name, a Type, and a
                  valid Quoted Amount</a
                >
              </b-modal>
              <!-- /Add Time Modal -->
              <!-- /Edit Time Modal -->
              <b-modal
                id="modal_editItem"
                title="Edit Item"
                title-class="font-18"
                ok-title="Edit Item"
                @ok="editItem"
              >
                <div class="mt-4 mt-lg-0 mb-4">
                  <div>
                    <b-form ref="form">
                      <b-form-group
                        label="Product/Service Name"
                        label-for="input-name"
                        :invalid-feedback="invalidFeedbackName"
                        :state="productName ? productInputValid : null"
                      >
                        <b-form-input
                          id="input-name"
                          v-model="productName"
                          :state="productName ? productInputValid : null"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group label="Type">
                        <b-form-select
                          v-model="type"
                          :options="typeOptions"
                        ></b-form-select>
                      </b-form-group>
                      <b-form-group
                        label="Quoted Amount"
                        label-for="input-quoted"
                        :invalid-feedback="invalidFeedbackQuotedAmount"
                        :state="quotedAmount ? quotedAmountValid : null"
                      >
                        <b-form-input
                          id="input-quoted"
                          v-model="quotedAmount"
                          :state="quotedAmount ? quotedAmountValid : null"
                          @keypress="
                            currencyAutoFormatter($event, quotedAmount)
                          "
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label="Received Amount"
                        label-for="input-received"
                        :invalid-feedback="invalidFeedbackReceivedAmount"
                        :state="receivedAmount ? receivedAmountValid : null"
                      >
                        <b-form-input
                          id="input-received"
                          v-model="receivedAmount"
                          :state="receivedAmount ? receivedAmountValid : null"
                          @keypress="
                            currencyAutoFormatter($event, receivedAmount)
                          "
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label="Mark-up"
                        label-for="input-markup"
                        :invalid-feedback="invalidFeedbackMarkup"
                        :state="markup ? markupValid : null"
                      >
                        <div class="mb-3">
                          <b-form-radio v-model="markupType" value="flatRate"
                            >Flat Rate</b-form-radio
                          >
                          <b-form-radio v-model="markupType" value="dollar"
                            >Cost Plus Dollar Amount</b-form-radio
                          >
                          <b-form-radio v-model="markupType" value="percentage"
                            >Cost Plus Percentage</b-form-radio
                          >
                        </div>
                        <b-input-group
                          :append="markupType === 'percentage' ? '%' : ''"
                          :prepend="
                            markupType === 'flatRate' || markupType === 'dollar'
                              ? '$'
                              : ''
                          "
                        >
                          <b-form-input
                            id="input-markup"
                            v-model="markup"
                            :state="markup ? markupValid : null"
                            :disabled="markupType === null"
                            @keypress="currencyAutoFormatter($event, markup)"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>

                      <b-form-checkbox
                        class="mt-3 mb-4"
                        id="checkbox-ordered"
                        v-model="ordered"
                        name="checkbox-ordered"
                        size="lg"
                      >
                        Product or service has been ordered
                      </b-form-checkbox>
                      <b-form-checkbox
                        class="mb-4"
                        id="checkbox-received"
                        v-model="received"
                        name="checkbox-received"
                        size="lg"
                      >
                        Product or service has been received
                      </b-form-checkbox>
                      <b-form-checkbox
                        class="mb-4"
                        id="checkbox-invoiced"
                        v-model="invoiced"
                        name="checkbox-invoiced"
                        size="lg"
                      >
                        Invoice has been received
                      </b-form-checkbox>
                      <b-form-checkbox
                        class="mb-4"
                        id="checkbox-billable"
                        v-model="billable"
                        name="checkbox-billable"
                        size="lg"
                      >
                        Exclude item from billing
                      </b-form-checkbox>
                      <b-form-group label="Image of Quote">
                        <b-button
                          v-if="quoteImage && quoteImagePresent"
                          @click="openImage(quoteImage.quoteURL)"
                          variant="primary"
                          >View</b-button
                        >
                        <b-button
                          v-if="quoteImage && quoteImagePresent"
                          @click="deleteImage(quoteImage.quoteName)"
                          variant="danger"
                          :pill="true"
                          size="sm"
                          class="ml-2"
                          >x</b-button
                        >
                        <vue-dropzone
                          v-else
                          id="fileUploader"
                          ref="fileUploader"
                          :use-custom-slot="true"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAddedQuote"
                        >
                          <div class="dropzone-custom-content">
                            <i
                              class="display-4 text-muted bx bxs-cloud-upload"
                            ></i>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </vue-dropzone>
                      </b-form-group>
                      <b-form-group label="Image of Invoice">
                        <b-button
                          v-if="invoiceImage && invoiceImagePresent"
                          @click="openImage(invoiceImage.invoiceURL)"
                          variant="primary"
                          >View</b-button
                        >
                        <b-button
                          v-if="invoiceImage && invoiceImagePresent"
                          @click="deleteImage(invoiceImage.invoiceName)"
                          variant="danger"
                          :pill="true"
                          size="sm"
                          class="ml-2"
                          >x</b-button
                        >

                        <vue-dropzone
                          v-else
                          id="fileUploader"
                          ref="fileUploader"
                          :use-custom-slot="true"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAddedInvoice"
                        >
                          <div class="dropzone-custom-content">
                            <i
                              class="display-4 text-muted bx bxs-cloud-upload"
                            ></i>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </vue-dropzone>
                      </b-form-group>
                    </b-form>
                  </div>
                </div>
                <a
                  :hidden="!submitErrorMessage"
                  class="badge badge-danger font-size-12 mr-1 ml-1 no-pointer float-right"
                  >Please input a valid Product/Service Name and a valid Quoted
                  Amount</a
                >
              </b-modal>
            </div>
          </div>
        </div>
        <div class="row mt-4 mb-1">
          <div class="col-12">
            <h5 v-if="totalQuotedAmount > 0">
              Total Quoted Amount:
              <strong>${{ totalQuotedAmount.toFixed(2) }}</strong>
            </h5>
          </div>
        </div>
        <div class="row mt-1 mb-1">
          <div class="col-12">
            <h5 v-if="totalReceivedAmount > 0">
              Total Received Amount:
              <strong>${{ totalReceivedAmount.toFixed(2) }}</strong>
            </h5>
          </div>
        </div>
        <div class="row mt-1 mb-1">
          <div class="col-12">
            <h5 v-if="totalReceivedAmount > 0">
              Difference:
              <strong
                :style="
                  totalQuotedAmount - totalReceivedAmount > 0
                    ? 'color: #28a745'
                    : 'color: #dc3545'
                "
                >${{
                  Math.abs(totalQuotedAmount - totalReceivedAmount).toFixed(2)
                }}</strong
              >
            </h5>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Show&nbsp;
                <b-form-select
                  v-model="itemsPerPage"
                  size="sm"
                  :options="itemsPageOptions"
                ></b-form-select
                >&nbsp;entries
              </label>
            </div>
          </div>

          <!-- Search -->
          <div class="col-sm-12 col-md-6">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-right"
            >
              <label class="d-inline-flex align-items-center">
                Search:
                <b-form-input
                  v-model="itemsFilter"
                  type="search"
                  placeholder="Search..."
                  class="form-control form-control-sm ml-2"
                ></b-form-input>
              </label>
            </div>
          </div>
          <!-- End search -->
        </div>

        <div class="table-responsive mb-0" style="text-align: center">
          <b-table
            :items="tableData"
            :fields="fields"
            responsive="sm"
            :per-page="itemsPerPage"
            :current-page="itemsCurrentPage"
            :sort-by.sync="itemsSortBy"
            :sort-desc.sync="itemsSortDesc"
            :sort-compare="tableSort"
            :filter="itemsFilter"
            :filter-included-fields="itemsFilterOn"
            :totalQuotedAmount="totalQuotedAmount"
            :totalReceivedAmount="totalReceivedAmount"
            primary-key="edit"
          >
            <template v-slot:cell(date)="data">
              <div>
                <span> {{ data.value.toString().substring(4, 15) }}</span>
              </div>
            </template>
            <template v-slot:cell(edit)="data">
              <b-dropdown variant="primary" size="sm">
                <template v-slot:button-content>
                  <i class="mdi mdi-chevron-down"></i>
                </template>
                <b-dropdown-item
                  v-b-modal.modal_editItem
                  @click="populateEditModal(data.item)"
                  ><i class="bx bx-edit-alt mr-2 tableIcons"></i
                  >Edit</b-dropdown-item
                >
                <b-dropdown-item
                  @click="
                    deleteItem(
                      data.item.receivedAmount,
                      data.item.quotedAmount,
                      data.item.edit,
                      data.item.quoteImage,
                      data.item.invoiceImage
                    )
                  "
                  ><i class="bx bx-trash mr-2 tableIcons"></i
                  >Delete</b-dropdown-item
                >
              </b-dropdown>
            </template>
            <!-- 
              
             -->
            <template v-slot:cell(billable)="data">
              <div
                :id="`procurementsBillable-${data.item.edit}`"
                style="display: inline-block"
              >
                <b-form-checkbox v-model="data.item.billable.value">
                </b-form-checkbox>
              </div>
              <b-tooltip
                :target="`procurementsBillable-${data.item.edit}`"
                triggers="hover"
                v-if="data.item.billable.value && data.item.billable"
              >
                {{
                  `Excluded from billing by ${
                    data.item.billable.name
                  } on ${data.item.billable.time
                    .toString()
                    .substring(0, 15)} at ${data.item.billable.time
                    .toString()
                    .substring(16, 21)}`
                }}
              </b-tooltip>
            </template>
            <template v-slot:cell(markup)="data">
              <div>
                <span
                  v-if="
                    data.value !== '' &&
                    (data.item.markupType === 'flatRate' ||
                      data.item.markupType === 'dollar')
                  "
                  >$</span
                >{{ data.value
                }}<span
                  v-if="
                    data.value !== '' && data.item.markupType === 'percentage'
                  "
                  >%</span
                >
              </div>
            </template>
            <template v-slot:cell(ordered)="data">
              <div>
                <span
                  v-b-tooltip.hover
                  :title="
                    data.value.value
                      ? `${data.value.name} on ${data.value.time
                          .toString()
                          .substring(4, 21)}`
                      : null
                  "
                  ><b-badge
                    :variant="data.value.value ? 'success' : 'danger'"
                    >{{ data.value.value ? 'Yes' : 'No' }}</b-badge
                  ></span
                >
              </div>
            </template>
            <template v-slot:cell(received)="data">
              <div>
                <span
                  v-b-tooltip.hover
                  :title="
                    data.value.value
                      ? `${data.value.name} on ${data.value.time
                          .toString()
                          .substring(4, 21)}`
                      : null
                  "
                  ><b-badge
                    :variant="data.value.value ? 'success' : 'danger'"
                    >{{ data.value.value ? 'Yes' : 'No' }}</b-badge
                  ></span
                >
              </div>
            </template>
            <template v-slot:cell(invoiced)="data">
              <div>
                <span
                  v-b-tooltip.hover
                  :title="
                    data.value.value
                      ? `${data.value.name} on ${data.value.time
                          .toString()
                          .substring(4, 21)}`
                      : null
                  "
                  ><b-badge
                    :variant="data.value.value ? 'success' : 'danger'"
                    >{{ data.value.value ? 'Yes' : 'No' }}</b-badge
                  ></span
                >
              </div>
            </template>
            <template v-slot:cell(quoteImage)="data">
              <div v-if="data.item.quoteImage">
                <b-button
                  @click="openImage(data.value.quoteURL)"
                  variant="primary"
                >
                  View
                </b-button>
              </div>
            </template>
            <template v-slot:cell(invoiceImage)="data">
              <div v-if="data.item.invoiceImage">
                <b-button
                  @click="openImage(data.value.invoiceURL)"
                  variant="primary"
                >
                  View
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="itemsCurrentPage"
                  :total-rows="itemsTotalRows"
                  :per-page="itemsPerPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import vue2Dropzone from 'vue2-dropzone';
import firebase from 'firebase';
import { firestore } from 'firebase';
import Swal from 'sweetalert2';
import { tableSort } from '../../helper/helpers';

import { uploadFile, deleteFile } from '../../helper/storageHelpers';
import VueToast from 'vue-toast-notification';
// Import one of the available themes
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

export default {
  data() {
    return {
      name: 'Procurement',
      dropzoneOptions: {
        url: '/',
        addRemoveLinks: true,
        method: 'put',
        chunking: true,
        forceChunking: true,
        autoQueue: false,
        autoProcessQueue: false,
        thumbnailWidth: 120,
        maxFiles: 1,
        maxFilesize: 250,
      },

      productName: '',
      quotedAmount: '',
      totalQuotedAmount: 0,
      receivedAmount: '',
      totalReceivedAmount: 0,
      markup: '',
      markupType: null,

      ordered: false,
      orderedInitial: null,
      orderedInitialUser: null,
      orderedInitialTime: null,
      orderedInitialUID: null,

      received: false,
      receivedInitial: null,
      receivedInitialUser: null,
      receivedInitialTime: null,
      receivedInitialUID: null,

      invoiced: false,
      invoicedInitial: null,
      invoicedInitialUser: null,
      invoicedInitialTime: null,
      invoicedInitialUID: null,

      billable: false,
      billableInitial: null,
      billableInitialUser: null,
      billableInitialTime: null,
      billableInitialUID: null,

      initialDate: null,
      productInputValid: false,
      quotedAmountValid: false,
      receivedAmountValid: false,
      markupValid: false,
      user: null,
      tableData: [],
      editID: null,
      quoteImage: null,
      invoiceImage: null,
      quoteImagePresent: null,
      invoiceImagePresent: null,
      filesToBeDeleted: [],
      flag: false,
      submitErrorMessage: false,
      type: null,
      typeOptions: ['', 'Materials', 'Rentals', '3rd Party', 'Other'],

      // itemsTotalRows: 1,
      itemsCurrentPage: 1,
      itemsPerPage: 10,
      itemsPageOptions: [10, 25, 50, 100],
      itemsFilter: null,
      itemsFilterOn: [],
      itemsSortBy: 'date',
      itemsSortDesc: true,

      fields: [
        {
          key: 'edit',
          sortable: false,
        },
        {
          key: 'billable',
          label: 'Exclude From Billing',
          sortable: true,
        },
        {
          key: 'date',
          sortable: true,
        },
        {
          key: 'name',
          sortable: true,
        },
        {
          key: 'quotedAmount',
          sortable: true,
        },
        {
          key: 'receivedAmount',
          sortable: true,
        },
        {
          key: 'markup',
          label: 'Mark-up',
          sortable: true,
        },
        { key: 'type', sortable: true },
        {
          key: 'ordered',
          sortable: true,
        },
        {
          key: 'received',
          sortable: true,
        },
        {
          key: 'invoiced',
          sortable: true,
        },
        { key: 'quoteImage', sortable: false },
        { key: 'invoiceImage', sortable: false },
      ],
      currentUser: this.$store.state.custom.currentUserData,
    };
  },
  props: { jobNum: Number, jobCustomer: String },
  components: { vueDropzone: vue2Dropzone },
  methods: {
    addItem: async function (bvModalEvt) {
      let user = JSON.parse(sessionStorage.authUser);
      let quote = null;
      let invoice = null;
      let date = new Date();
      //check if input is valid
      if (
        this.productInputValid &&
        this.quotedAmountValid &&
        this.type &&
        this.type !== ''
      ) {
        this.submitErrorMessage = false;

        //upload any images added and store their names and urls in an array to add to the firestore object
        try {
          if (this.quoteImage) {
            quote = await this.onFileAdded(this.quoteImage, true);
          }
          if (this.invoiceImage) {
            invoice = await this.onFileAdded(this.invoiceImage, true);
          }
        } catch (err) {
          console.log('Error adding image.', err);
          Swal.fire(
            'Error!',
            'An error was encountered when storing the image.',
            'error'
          );
        }
        //update the firestore with the information, including any images that were added
        try {
          //create the form object that we can validate and insert.
          let validatedForm = {
            createdBy: { id: user.uid, name: user.displayName },
            name: this.productName.trim(),
            org: sessionStorage.org,
            customer: this.jobCustomer.toLowerCase(),
            jobNum: this.jobNum,
            billable: {
              value: this.billable,
              time: this.billable ? new Date(date) : null,
              name: this.billable ? user.displayName : null,
              uid: this.billable ? user.uid : null,
            },

            quotedAmount: this.quotedAmount,
            receivedAmount: this.receivedAmount,
            markup: this.markup,
            markupType: this.markupType,
            type: this.type,
            ordered: {
              value: this.ordered,
              time: this.ordered ? new Date(date) : null,
              name: this.ordered ? user.displayName : null,
              uid: this.ordered ? user.uid : null,
            },

            received: {
              value: this.received,
              time: this.received ? new Date(date) : null,
              name: this.received ? user.displayName : null,
              uid: this.received ? user.uid : null,
            },

            invoiced: {
              value: this.invoiced,
              time: this.invoiced ? new Date(date) : null,
              name: this.invoiced ? user.displayName : null,
              uid: this.invoiced ? user.uid : null,
            },

            date: new Date(date),
            quoteImage: quote
              ? {
                  quoteURL: quote[1],
                  quoteName: `${quote[2]}-${quote[3]}`,
                }
              : null,
            invoiceImage: invoice
              ? {
                  invoiceURL: invoice[1],
                  invoiceName: `${invoice[2]}-${invoice[3]}`,
                }
              : null,
          };

          firestore()
            .collection('procurements')
            .add(validatedForm)
            .then((doc) => {
              //populate the rest of the object with the info that is needed for the table and edit.

              validatedForm['edit'] = doc.id;

              this.tableData.push(validatedForm);
              this.totalQuotedAmount += Number(this.quotedAmount);
              this.totalReceivedAmount += Number(this.receivedAmount);

              Swal.fire('Success!', 'Item added successfully.', 'success');
            })
            .catch(async (error) => {
              //if the firestore update fails, we need to remove any images uploaded from storage
              //it isn't the worst thing ever if this were to fail, it would just mean we have unused images sitting in storage
              try {
                if (this.quoteImage) {
                  quote = await deleteFile(
                    this.quoteImage.name,
                    this.jobNum,
                    true
                  );
                }
                if (this.invoiceImage) {
                  invoice = await deleteFile(
                    this.invoiceImage.name,
                    this.jobNum,
                    true
                  );
                }
              } catch (err) {
                console.log('Error adding item.', err);
                Swal.fire(
                  'Error!',
                  'An error was encountered when adding the item.',
                  'error'
                );
              }
              console.log(`Error adding item.`, error);
              Swal.fire(
                'Error!',
                'An error was encountered when inserting the item.',
                'error'
              );
            });
          this.productInputValid = null;
          this.quotedAmountValid = null;
          this.receivedAmountValid = null;
          this.markupValid = null;
        } catch (err) {
          console.log('Error adding item.', err);
          Swal.fire(
            'Error!',
            'An error was encountered when inserting the item.',
            'error'
          );
        }
      } else {
        this.submitErrorMessage = true;

        bvModalEvt.preventDefault();
      }
    },
    editItem: async function (bvModalEvt) {
      let user = JSON.parse(sessionStorage.authUser);
      let quote = null;
      let invoice = null;
      let date = new Date();

      //check if input is valid
      if (
        this.productInputValid &&
        this.quotedAmountValid &&
        this.receivedAmountValid &&
        this.markupValid &&
        this.type &&
        this.type !== ''
      ) {
        this.submitErrorMessage = false;

        try {
          //upload any images that were added
          if (this.quoteImage && this.quoteImagePresent) {
            quote = [];
            quote[1] = this.quoteImage.quoteURL;
            quote[2] = this.quoteImage.quoteName;
          } else if (this.quoteImage && !this.quoteImagePresent) {
            quote = await this.onFileAdded(this.quoteImage, true);
          }
          if (this.invoiceImage && this.invoiceImagePresent) {
            invoice = [];
            invoice[1] = this.invoiceImage.invoiceURL;
            invoice[2] = this.invoiceImage.invoiceName;
          } else if (this.invoiceImage && !this.invoiceImagePresent) {
            invoice = await this.onFileAdded(this.invoiceImage, true);
          }
        } catch (err) {
          console.log('Error adding image.', err);
          Swal.fire(
            'Error!',
            'An error was encountered when storing the image.',
            'error'
          );
        }
        //update the firestore with the information, including any images that were added

        try {
          //create the form object that we can validate and insert.
          let validatedForm = {
            name: this.productName.trim(),
            org: sessionStorage.org,
            customer: this.jobCustomer.toLowerCase(),
            jobNum: this.jobNum,
            quotedAmount: this.quotedAmount,
            receivedAmount: this.receivedAmount,
            markup: this.markup,
            markupType: this.markupType,
            type: this.type,
            // for ordered, received and invoiced, we check to see if the value is different than when the edit modal opened,
            //and change the user and time if it is
            ordered: {
              value: this.ordered,
              time: this.ordered
                ? this.ordered !== this.orderedInitial
                  ? new Date(date)
                  : this.orderedInitialTime
                : null,
              name: this.ordered
                ? this.ordered !== this.orderedInitial
                  ? user.displayName
                  : this.orderedInitialUser
                : null,
              uid: this.ordered
                ? this.ordered !== this.orderedInitial
                  ? user.uid
                  : this.orderedInitialUID
                : null,
            },

            received: {
              value: this.received,
              time: this.received
                ? this.received !== this.receivedInitial
                  ? new Date(date)
                  : this.receivedInitialTime
                : null,
              name: this.received
                ? this.received !== this.receivedInitial
                  ? user.displayName
                  : this.receivedInitialUser
                : null,
              uid: this.received
                ? this.received !== this.receivedInitial
                  ? user.uid
                  : this.receivedInitialUID
                : null,
            },

            invoiced: {
              value: this.invoiced,
              time: this.invoiced
                ? this.invoiced !== this.invoicedInitial
                  ? new Date(date)
                  : this.invoicedInitialTime
                : null,
              name: this.invoiced
                ? this.invoiced !== this.invoicedInitial
                  ? user.displayName
                  : this.invoicedInitialUser
                : null,
              uid: this.invoiced
                ? this.invoiced !== this.invoicedInitial
                  ? user.uid
                  : this.invoicedInitialUID
                : null,
            },
            billable: {
              value: this.billable,
              time: this.billable
                ? this.billable !== this.billableInitial
                  ? new Date(date)
                  : this.billableInitialTime
                : null,
              name: this.billable
                ? this.billable !== this.billableInitial
                  ? user.displayName
                  : this.billableInitialUser
                : null,
              uid: this.billable
                ? this.billable !== this.billableInitial
                  ? user.uid
                  : this.billableInitialUID
                : null,
            },

            date: this.initialDate,
            quoteImage: quote
              ? {
                  quoteURL: quote[1],
                  quoteName: quote[3] ? `${quote[2]}-${quote[3]}` : quote[2],
                }
              : null,
            invoiceImage: invoice
              ? {
                  invoiceURL: invoice[1],
                  invoiceName: invoice[3]
                    ? `${invoice[2]}-${invoice[3]}`
                    : invoice[2],
                }
              : null,
          };

          firestore()
            .collection('procurements')
            .doc(this.editID)
            .update(validatedForm)
            .then(() => {
              //populate the rest of the object with the info that is needed for the table and edit.

              validatedForm['edit'] = this.editID;

              let i = this.tableData.findIndex((o) => o.edit == this.editID);
              this.tableData.splice(i, 1, validatedForm);
              if (this.quotedAmountInitial !== this.quotedAmount) {
                this.totalQuotedAmount -= Number(this.quotedAmountInitial);
                this.totalQuotedAmount += Number(this.quotedAmount);
              }
              if (this.receivedAmountInitial !== this.receivedAmount) {
                this.totalReceivedAmount -= Number(this.receivedAmountInitial);
                this.totalReceivedAmount += Number(this.receivedAmount);
              }
              Swal.fire('Success!', 'Item edited successfully.', 'success');
            })
            .catch(async (err) => {
              //if the firestore update fails then we need to delete the newly uploaded images from storage
              try {
                if (this.quoteImage && !this.quoteImagePresent) {
                  await deleteFile(this.quoteImage.name, this.jobNum, true);
                }
                if (this.invoiceImage && !this.invoiceImagePresent) {
                  await deleteFile(this.invoiceImage.name, this.jobNum, true);
                }
              } catch (err) {
                console.log('Error removing image from storage.', err);
                Swal.fire(
                  'Error!',
                  'An error was encountered removing an image from storage.',
                  'error'
                );
              }
              console.log(`Error editing item.`, err);
              Swal.fire(
                'Error!',
                'An error was encountered when editing the item.',
                'error'
              );
            });
        } catch (err) {
          console.log(err);
          Swal.fire(
            'Error!',
            'An error was encountered when editing the item.',
            'error'
          );
        }
        try {
          // if the upload is successful, delete any images that were removed from storage
          this.filesToBeDeleted.forEach(async (file) => {
            let success = await deleteFile(file, this.jobNum, true);
            if (success) {
              console.log('success');
            } else {
              console.log('error removing unused image from storage');
            }
          });
          this.filesToBeDeleted = [];
        } catch (err) {
          console.log('error removing unused image from storage', err);
        }
      } else {
        this.submitErrorMessage = true;

        bvModalEvt.preventDefault();
      }
    },
    deleteItem: function (
      receivedAmount,
      quotedAmount,
      id,
      quoteImage,
      invoiceImage
    ) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This item will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          firestore()
            .collection('procurements')
            .doc(id)
            .delete()
            .then(async () => {
              try {
                if (quoteImage) {
                  let success = await deleteFile(
                    quoteImage.quoteName,
                    this.jobNum,
                    true
                  );
                  if (success) {
                    console.log('success');
                  } else {
                    Swal.fire('Error!', 'Error deleting file.', 'error');
                  }
                }
                if (invoiceImage) {
                  let success = await deleteFile(
                    invoiceImage.invoiceName,
                    this.jobNum,
                    true
                  );
                  if (success) {
                    console.log('success');
                  } else {
                    Swal.fire('Error!', 'Error deleting file.', 'error');
                  }
                }
              } catch (error) {
                console.log('Error deleting images', error);
                Swal.fire('Error!', 'Error deleting file.', 'error');
              }
            })
            .then(() => {
              this.tableData = this.tableData.filter(function (obj) {
                return obj.edit !== id;
              });
              this.totalQuotedAmount -= quotedAmount;
              this.totalReceivedAmount -= receivedAmount;

              Swal.fire(
                'Deleted!',
                'The selected item was successfully deleted.',
                'success'
              );
            })
            .catch(() => {
              Swal.fire(
                'Error!',
                'An error was encounted when deleting the record.',
                'error'
              );
            });
        }
      });
    },
    openImage: function (url) {
      var win = window.open(url, '_blank');
      win.focus();
    },
    updateBillable: async function (value, id) {
      try {
        let db = firebase.firestore();
        let page = db.collection('procurements').doc(id);
        let user = JSON.parse(sessionStorage.authUser);
        let approvedTime = Date.now();

        let index = this.tableData.findIndex((data) => data.edit === id);
        let newData = JSON.parse(JSON.stringify(this.tableData[index]));

        newData.billable = value
          ? {
              name: user.displayName,
              time: new Date(approvedTime),
              uid: user.uid,
              value: value,
            }
          : {
              name: null,
              time: null,
              uid: null,
              value: value,
            };
        await page
          .update({
            billable: newData.billable,
          })
          .then(() => {
            newData.date = new Date(newData.date);
            this.tableData.splice(index, 1, newData);
            Vue.$toast.open({
              message: value
                ? 'Procurement excluded from billing successfully'
                : 'Procurement included in billing successfully',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            console.log(`Error changing Procurement billable approval status.`);
            Swal.fire(
              'Error!',
              'An error was encountered when changing the Procurements billable approval status',
              'error'
            );
          });
      } catch (error) {
        console.log('An error occured: ', error);
      }
    },
    clearAddModal: function () {
      this.productName = '';
      this.quotedAmount = '';
      this.receivedAmount = '';
      this.markup = '';
      this.markupType = null;
      this.type = null;
      this.ordered = false;
      this.received = false;
      this.invoiced = false;
      this.billable = false;
      this.productInputValid = false;
      this.quotedAmountValid = false;
      this.receivedAmountValid = false;
      this.markupValid = false;
      this.quoteImage = null;
      this.invoiceImage = null;
    },
    populateEditModal: function (data) {
      //populate the edit modal with all the information we need for the editItem function
      this.submitErrorMessage = false;
      this.productInputValid = true;
      this.quotedAmountValid = true;
      this.receivedAmountValid = true;
      this.markupValid = true;

      this.productName = data.name;
      this.quotedAmount = data.quotedAmount;
      this.quotedAmountInitial = data.quotedAmount;
      this.receivedAmount = data.receivedAmount ? data.receivedAmount : '';
      this.receivedAmountInitial = data.receivedAmount
        ? data.receivedAmount
        : '';
      this.markup = data.markup ? data.markup : '';
      this.markupType = data.markupType ? data.markupType : null;
      this.type = data.type ? data.type : null;
      this.ordered = data.ordered.value;
      this.orderedInitial = data.ordered.value;
      this.orderedInitialUser = data.ordered.name;
      this.orderedInitialTime = data.ordered.time;
      this.orderedInitialUID = data.ordered.uid;

      this.received = data.received.value;
      this.receivedInitial = data.received.value;
      this.receivedInitialUser = data.received.name;
      this.receivedInitialTime = data.received.time;
      this.receivedInitialUID = data.received.uid;

      this.invoiced = data.invoiced.value;
      this.invoicedInitial = data.invoiced.value;
      this.invoicedInitialUser = data.invoiced.name;
      this.invoicedInitialTime = data.invoiced.time;
      this.invoicedInitialUID = data.invoiced.uid;

      this.billable = data.billable.value;
      this.billableInitial = data.billable.value;
      this.billableInitialUser = data.billable.name;
      this.billableInitialTime = data.billable.time;
      this.billableInitialUID = data.billable.uid;

      this.editID = data.edit;
      this.initialDate = data.date;
      this.quoteImage = data.quoteImage;
      this.invoiceImage = data.invoiceImage;
      this.quoteImagePresent = data.quoteImage ? true : false;
      this.invoiceImagePresent = data.invoiceImage ? true : false;
    },
    getProcurementData: async function () {
      let index;
      try {
        firestore()
          .collection('procurements')
          .where('jobNum', '==', this.jobNum)
          .where('org', '==', sessionStorage.org)
          .get()
          .then((querySnapshot) => {
            //TODO:
            if (querySnapshot.empty && !this.flag) {
              setTimeout(this.getProcurementData, 500);
              this.flag = true;
            }
            this.totalQuotedAmount = 0;
            this.totalReceivedAmount = 0;

            querySnapshot.forEach((doc) => {
              index = this.tableData.push(doc.data());
              this.tableData[index - 1]['edit'] = doc.id;
              this.changeTimeFormats(index - 1);
              this.totalQuotedAmount += Number(doc.data().quotedAmount);
              if (doc.data().receivedAmount) {
                this.totalReceivedAmount += Number(doc.data().receivedAmount);
              }
              if (!doc.data().billable) {
                this.tableData[index - 1]['billable'] = {
                  name: null,
                  time: null,
                  uid: null,
                  value: false,
                };
              }
            });
          });
      } catch (err) {
        console.log(`Error getting procurement data ${err}`);
        Vue.$toast.open({
          message: 'Error getting procurement data',
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    changeTimeFormats(index) {
      this.tableData[index].date = this.tableData[index].date.toDate();
      if (this.tableData[index].ordered.time) {
        this.tableData[index].ordered.time =
          this.tableData[index].ordered.time.toDate();
      }
      if (this.tableData[index].received.time) {
        this.tableData[index].received.time =
          this.tableData[index].received.time.toDate();
      }
      if (this.tableData[index].invoiced.time) {
        this.tableData[index].invoiced.time =
          this.tableData[index].invoiced.time.toDate();
      }
      if (this.tableData[index].billable) {
        if (this.tableData[index].billable.time) {
          this.tableData[index].billable.time =
            this.tableData[index].billable.time.toDate();
        }
      }
    },
    fileAddedQuote: function (file) {
      this.quoteImage = file;
    },
    fileAddedInvoice: function (file) {
      this.invoiceImage = file;
    },
    onFileAdded: async function (file, procurement) {
      let retArr = await uploadFile(file, this.jobNum, procurement);
      if (retArr[0] == true) {
        console.log('not failed');

        return retArr;
      } else {
        console.log('failed');
      }
    },
    deleteImage: function (file) {
      /*this function is called when the user deletes an image in the edit modal, if the image is one that has already been uploaded,
      it adds the image to a list of files to be deleted once the user hits submit, if it is not uploaded yet it just sets the variable to null*/
      Swal.fire({
        title: 'Are you sure?',
        text: 'This file will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then(async (result) => {
        if (result.value) {
          if (this.quoteImage) {
            if (file === this.quoteImage.quoteName && this.quoteImagePresent) {
              this.filesToBeDeleted.push(file);
              this.quoteImage = null;
              this.quoteImagePresent = false;
            } else if (
              file === this.quoteImage.quoteName &&
              !this.quoteImagePresent
            ) {
              this.quoteImage = null;
              this.quoteImagePresent = false;
            }
          }
          if (this.invoiceImage) {
            if (
              file === this.invoiceImage.invoiceName &&
              this.invoiceImagePresent
            ) {
              this.filesToBeDeleted.push(file);

              this.invoiceImage = null;
              this.invoiceImagePresent = false;
            } else if (
              file === this.invoiceImage.invoiceName &&
              !this.invoiceImagePresent
            ) {
              this.invoiceImage = null;
              this.invoiceImagePresent = false;
            }
          }
        } else {
          Swal.fire('Error!', 'Error deleting file.', 'error');
        }
      });
    },
    changeValidationValue(field, value) {
      if (field === 'product') {
        this.productInputValid = value;
      } else if (field === 'quoted') {
        this.quotedAmountValid = value;
      } else if (field === 'received') {
        this.receivedAmountValid = value;
      } else if (field === 'markup') {
        this.markupValid = value;
      }
    },
    currencyAutoFormatter($event, value) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if (
        (keyCode < 48 || keyCode > 57) &&
        (keyCode !== 46 || value.indexOf('.') != -1)
      ) {
        // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (
        value != null &&
        value.indexOf('.') > -1 &&
        value.split('.')[1].length > 1
      ) {
        $event.preventDefault();
      }
    },
    setTableSettings: function () {
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_procurement) {
          this.itemsPerPage =
            this.currentUser.tablePageLengths.perPage_procurement;
        }
      }
    },
    tableSort: tableSort,
  },
  mounted() {
    this.getProcurementData();
    this.setTableSettings();
  },
  computed: {
    itemsTotalRows() {
      return this.tableData.length;
    },
    invalidFeedbackName() {
      if (
        this.productName === null ||
        this.productName === undefined ||
        this.productName.trim() === ''
      ) {
        this.changeValidationValue('product', false);
        return 'Please enter a product or service name';
      } else {
        this.changeValidationValue('product', true);
      }
      return 'Please enter a product or service name';
    },
    invalidFeedbackQuotedAmount() {
      if (
        this.quotedAmount === null ||
        this.quotedAmount === undefined ||
        this.quotedAmount.trim() === ''
      ) {
        this.changeValidationValue('quoted', false);

        return 'Please enter the amount quoted for the product or service';
      } else if (isNaN(this.quotedAmount.trim())) {
        this.changeValidationValue('quoted', false);
        return 'The amount quoted must be a number';
      } else {
        this.changeValidationValue('quoted', true);
      }
      return 'Please enter the amount quoted for the product or service';
    },
    invalidFeedbackReceivedAmount() {
      if (isNaN(this.receivedAmount.trim())) {
        this.changeValidationValue('received', false);
        return 'The amount received must be a number';
      } else {
        this.changeValidationValue('received', true);
      }
      return '';
    },
    invalidFeedbackMarkup() {
      if (isNaN(this.markup.trim())) {
        this.changeValidationValue('markup', false);
        return 'The amount received must be a number';
      } else {
        this.changeValidationValue('markup', true);
      }
      return '';
    },
    excludeBilling() {
      return this.tableData.map((data) => ({
        id: data.edit,
        billable: data.billable.value,
      }));
    },
  },
  watch: {
    excludeBilling(newValue, oldValue) {
      if (oldValue.length > 0) {
        // find new billable item
        let billableValue = newValue.find(
          (x, index) => x.billable !== oldValue[index].billable
        );
        // if new billable item exists pass it to updateTimeBillable method
        if (billableValue !== undefined) {
          this.updateBillable(billableValue.billable, billableValue.id);
        }
      }
    },
    itemsPerPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentUser = this.$store.state.custom.currentUserData;
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_procurement){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_procurement;
          }
          currentUserDataCopy.tablePageLengths['perPage_procurement'] = newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_procurement: newVal,
          };
        }

        // prevent a write after page render, only write to db when user manually changes page length setting
        if (oldCurrentUserPerPage !== newVal) {
          firebase
            .firestore()
            .collection('employees')
            .doc(this.currentUser.auth)
            .update({
              tablePageLengths: currentUserDataCopy.tablePageLengths,
            });
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  },
};
</script>
